export const arrayMenuCentral = [
  {
    id: 1,
    key: 'mst',
    name: 'Maestro',
    vista: '#MAESTRO',
    arraySubItem: [
      {
        id: 1,
        title: 'Empresa',
        submenu: 'enterprise',
        showPanel: false,
        vista: '#EMPRESA',
        content: {
          headerPanel: 'table-enterprise',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Persona',
        submenu: 'person',
        showPanel: false,
        vista: '#PERSONA',
        content: {
          headerPanel: 'table-person',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Exportar Datos',
        submenu: 'export-data',
        showPanel: false,
        vista: '#EXPORTAR DATOS',
        content: {
          headerPanel: 'table-export',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 2,
    key: 'seg',
    name: 'Seguridad',
    vista: '#SEGURIDAD',
    arraySubItem: [
      {
        id: 2,
        title: 'Usuario',
        submenu: 'user',
        showPanel: false,
        vista: '#USUARIO',
        content: {
          headerPanel: 'table-user',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Opción',
        submenu: 'option',
        showPanel: false,
        vista: '#OPCION',
        content: {
          headerPanel: 'table-option',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Perfil',
        submenu: 'profile',
        showPanel: false,
        vista: '#PERFIL',
        content: {
          headerPanel: 'table-profile',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 3,
    key: 'dpl',
    name: 'Despliegues',
    vista: '#DESPLIEGUE',
    arraySubItem: [
      {
        id: 2,
        title: 'Compañía',
        submenu: 'company',
        showPanel: false,
        vista: '#COMPANIA',
        content: {
          headerPanel: 'table-company',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Cliente',
        submenu: 'client',
        showPanel: false,
        vista: '#CLIENTE',
        content: {
          headerPanel: 'table-client',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Sites',
        submenu: 'site',
        showPanel: false,
        vista: '#SITE',
        content: {
          headerPanel: 'table-site',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 5,
        title: 'Campamentos',
        submenu: 'camp',
        showPanel: false,
        vista: '#CAMPAMENTO',
        content: {
          headerPanel: 'table-camp',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 6,
        title: 'Recepcionador de servicio',
        submenu: 'contract',
        showPanel: false,
        vista: '#RECEPCIONADOR DE SERVICIO',
        content: {
          headerPanel: 'table-contract',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 7,
        title: 'Registro de requerimientos, quejas y/o reclamos',
        submenu: 'claim',
        showPanel: false,
        vista: '#REGISTRO DE REQUERIMIENTOS QUEJAS YO RECLAMOS',
        content: {
          headerPanel: 'table-claim',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 4,
    key: 'dpl',
    name: 'Configuración',
    vista: '#CONFIGURACION',
    arraySubItem: [
      {
        id: 2,
        title: 'Plantillas email',
        submenu: 'emailtemplate',
        showPanel: false,
        vista: '#PLANTILLAS EMAIL',
        content: {
          headerPanel: 'table-emailtemplate',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Parámetros de reporte de facturación',
        submenu: 'parameters',
        showPanel: false,
        vista: '#PARAMETROS DE REPORTE DE FACTURACION',
        content: {
          headerPanel: 'table-parameters',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Categorías',
        submenu: 'category',
        showPanel: false,
        vista: '#CATEGORIA',
        content: {
          headerPanel: 'table-category',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 5,
        title: 'Parámetros',
        submenu: 'params',
        showPanel: false,
        vista: '#PARAMETROS',
        content: {
          headerPanel: 'table-params',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 6,
        title: 'Rangos de Parámetros',
        submenu: 'rangeparams',
        showPanel: false,
        vista: '#RANGOS DE PARAMETROS',
        content: {
          headerPanel: 'table-range-params',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 7,
        title: 'Configurador de Documento',
        submenu: 'config-document',
        showPanel: false,
        vista: '#CONFIGURADOR DE DOCUMENTO',
        content: {
          headerPanel: 'table-config-document',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 8,
        title: 'Configurador de Facturación',
        submenu: 'config-facturation',
        showPanel: false,
        vista: '#CONFIGURADOR DE FACTURACION',
        content: {
          headerPanel: 'table-config-facturation',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 5,
    key: 'app-huesped',
    name: 'App Huesped',
    vista: '#APP HUESPED',
    arraySubItem: [
      {
        id: 2,
        title: 'Registro de reclamos usuario',
        submenu: 'claim-user',
        showPanel: false,
        vista: '#REGISTRO DE RECLAMOS USUARIO',
        content: {
          headerPanel: 'table-claim-user',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
]
